import { render, staticRenderFns } from "./AddReports.vue?vue&type=template&id=0f210fc1&"
import script from "./AddReports.vue?vue&type=script&lang=ts&"
export * from "./AddReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports